import React from "react";
import * as styles from "./ComponentCTA.module.css";
import { ComponentProps } from "../../../types/index";
import { Cta, LinkCtaProps } from "../../elements/Cta/Cta";
import { CTAStyles } from "./index";
import { darkBrandColors } from "../../../lib/color";

interface Props extends ComponentProps {
  cta: LinkCtaProps;
  style: CTAStyles;
  leftAlign?: boolean;
}

export const ComponentCTA: React.FC<Props> = ({
  anchor,
  hideOnMobile,
  style,
  leftAlign,
  cta,
}) => {
  const classes = [styles.componentcta];
  leftAlign && classes.push(styles.left);
  hideOnMobile && classes.push("hide-mobile");
  //legacy styles are "green" and "white" these map to black and white in new color palette
  const backgroundColor =
    style?.split("background_")[1]?.replace(/_/g, "-") ||
    (style === "green" ? "black" : "white");
  const textColor = darkBrandColors.includes(backgroundColor)
    ? "white"
    : "black";
  return (
    <div id={anchor} className={classes.join(" ")}>
      <Cta
        {...cta}
        invert={textColor === "black" ? true : false}
        backgroundColor={backgroundColor}
      />
    </div>
  );
};
